import React from 'react';
import { motion } from 'framer-motion';
import Hero from './components/Hero';
import About from './components/About';
import Solutions from './components/Solutions';
import Nucleus from './components/Nucleus';
import WhyChooseUs from './components/WhyChooseUs';
// import SuccessStories from './components/SuccessStories';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <header className="fixed top-0 left-0 right-0 z-50 bg-deep-blue/90 backdrop-blur-md border-b border-electric-blue/20">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="flex items-center"
          >
            <span className="text-2xl font-display font-bold gradient-text">Atomcx.ai</span>
          </motion.div>
          <nav>
            <ul className="flex space-x-6">
              <li><a href="#about" className="text-white hover:text-electric-blue transition-colors">About</a></li>
              <li><a href="#solutions" className="text-white hover:text-electric-blue transition-colors">Solutions</a></li>
              <li><a href="#nucleus" className="text-white hover:text-electric-blue transition-colors">Nucleus</a></li>
              <li><a href="#why-choose-us" className="text-white hover:text-electric-blue transition-colors">Why Us</a></li>
              {/* <li><a href="#success-stories" className="text-white hover:text-electric-blue transition-colors">Success Stories</a></li> */}
              <li><a href="#contact" className="px-4 py-2 bg-gradient-to-r from-electric-blue to-teal-accent rounded-md text-deep-blue font-semibold hover:shadow-neon transition-all">Contact</a></li>
            </ul>
          </nav>
        </div>
      </header>

      <main>
        <Hero />
        <About />
        <Solutions />
        <Nucleus />
        <WhyChooseUs />
        {/* <SuccessStories /> */}
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;
